module.exports = __webpack_public_path__ + "static/media/arrow-down-blue.610a7f7d.svg";